import React, { useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
  faUtensils,
} from "@fortawesome/free-solid-svg-icons";

const getNumberValue = (value) => Number(value) || 0;

const getDiscountPercentage = (regularPrice, offerPrice) => {
  const regular = getNumberValue(regularPrice);
  const offer = getNumberValue(offerPrice);

  if (regular <= 0 || offer <= 0 || offer >= regular) {
    return 0;
  }

  return Math.round(((regular - offer) / regular) * 100);
};

export default function RestaurantOffersCarousel(props) {
  const { offers, onSelectOffer } = props;
  const railRef = useRef(null);
  const [failedOfferImages, setFailedOfferImages] = useState({});

  if (!offers || offers.length === 0) {
    return null;
  }

  const scrollOffers = (direction) => {
    if (!railRef.current) {
      return;
    }

    const cardWidth = 260;
    railRef.current.scrollBy({
      left: direction * cardWidth,
      behavior: "smooth",
    });
  };

  return (
    <section className="restaurant-offers-carousel">
      <div className="restaurant-offers-carousel_header">
        <h3>Deals for you</h3>
        <div className="restaurant-offers-carousel_controls">
          <button
            type="button"
            className="restaurant-offers-carousel_control"
            onClick={() => scrollOffers(-1)}
            aria-label="Scroll offers left"
          >
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>
          <button
            type="button"
            className="restaurant-offers-carousel_control"
            onClick={() => scrollOffers(1)}
            aria-label="Scroll offers right"
          >
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
        </div>
      </div>

      <div ref={railRef} className="restaurant-offers-carousel_rail">
        {offers.map((offer) => {
          const discountPercentage = getDiscountPercentage(
            offer.dish_price,
            offer.dish_offer_price,
          );

          return (
            <article
              key={offer.dish_id}
              className="restaurant-offers-card"
              onClick={() => onSelectOffer(offer.dish_id)}
              role="button"
              tabIndex={0}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  onSelectOffer(offer.dish_id);
                }
              }}
            >
              <div className="restaurant-offers-card_image">
                {offer.dish_image && !failedOfferImages[offer.dish_id] ? (
                  <img
                    src={offer.dish_image}
                    alt={offer.dish_name}
                    onError={() =>
                      setFailedOfferImages((currentFailedImages) =>
                        currentFailedImages[offer.dish_id]
                          ? currentFailedImages
                          : {
                              ...currentFailedImages,
                              [offer.dish_id]: true,
                            },
                      )
                    }
                  />
                ) : (
                  <div className="restaurant-offers-card_placeholder">
                    <FontAwesomeIcon icon={faUtensils} />
                  </div>
                )}
                <span className="restaurant-offers-card_badge">
                  {discountPercentage}% OFF
                </span>
              </div>

              <div className="restaurant-offers-card_body">
                <h4>{offer.dish_name}</h4>
                <p>
                  {offer.dish_description ||
                    "Discounted dish ready to order from this restaurant."}
                </p>
                <div className="restaurant-offers-card_price">
                  <strong>${offer.dish_offer_price}</strong>
                  <span>${offer.dish_price}</span>
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}
